import * as React from "react";
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  CardActions,
  Button
} from "@material-ui/core";
import { Link as LinkClass } from "../../../api/classes";
import CaseLink from "./link";
import { FacebookVirality } from "src/pages/tools/facebookVirality";
interface Props {
  link: LinkClass;
  style?: React.CSSProperties;
}
interface State {}
export default class LinkMeta extends React.Component<Props, State> {
  render() {
    const { link } = this.props;
    if (
      !this.props.link.meta_title ||
      this.props.link.meta_title === null ||
      this.props.link.meta_title.length === 0
    ) {
      return <CaseLink style={this.props.style} link={this.props.link} />;
    }
    return (
      <Card
        style={{
          ...this.props.style,
          maxWidth: 450,
          marginTop: 8,
          width: "100%"
        }}
      >
        {this.props.link.meta_title && this.props.link.meta_title !== null && (
          <>
            <CardMedia
              style={{
                height: 140
              }}
              image={link.image}
              title="Contemplative Reptile"
            />
            <CardContent>
              <Typography gutterBottom variant="headline" component="h2">
                {link.meta_title && link.meta_title.length > 0
                  ? link.meta_title.substr(0, 50)
                  : link.link}
              </Typography>
              <Typography component="p">{link.meta_description}</Typography>
            </CardContent>
          </>
        )}
        <CardActions>
          <a
            target="_blank"
            href={link.link}
            style={{ textDecoration: "none" }}
          >
            <Button size="small" color="primary">
              Original
            </Button>
          </a>
          <a
            target="_blank"
            href={"http://teyit.link/" + link.teyitlink_slug}
            style={{ textDecoration: "none" }}
          >
            <Button size="small" color="primary">
              Teyit.link
            </Button>
          </a>
        </CardActions>
        <FacebookVirality url={link.link} />
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/cases/components/linkMeta.tsx